import { emptyObj } from 'util/objects'

export const base = state => state.kb.articles || emptyObj
